import { useMemo } from "react";
import { useAccount, useWatchContractEvent } from "wagmi";
import { mainnetTokenContracts, testnetTokenContracts, } from "../lib/contracts";
import { usePassportContext } from "./usePassportContext";
import { CHAIN_ID } from "../constants";
import { useRefreshPassport } from "./useRefreshPassport";
import { simpleWssMezoConfig } from "../config";
function useWatchTransferEvents(token) {
    const { address: userAddress } = useAccount();
    const { environment = "mainnet" } = usePassportContext();
    const { refreshTokensBalances, refreshBorrowData } = useRefreshPassport();
    const contract = useMemo(() => {
        const contracts = environment === "mainnet" ? mainnetTokenContracts : testnetTokenContracts;
        return contracts[token];
    }, [environment, token]);
    useWatchContractEvent({
        address: contract.address,
        abi: contract.abi,
        eventName: "Transfer",
        args: {
            from: userAddress,
        },
        chainId: CHAIN_ID[environment],
        enabled: !!userAddress,
        config: simpleWssMezoConfig,
        onLogs() {
            console.log(`[${token}] Transfer from: ${userAddress}`);
            refreshTokensBalances();
            refreshBorrowData();
        },
    });
    useWatchContractEvent({
        address: contract.address,
        abi: contract.abi,
        eventName: "Transfer",
        args: {
            to: userAddress,
        },
        chainId: CHAIN_ID[environment],
        enabled: !!userAddress,
        config: simpleWssMezoConfig,
        onLogs() {
            console.log(`[${token}] Transfer to: ${userAddress}`);
            refreshTokensBalances();
            refreshBorrowData();
        },
    });
}
function useWatchTransferEventsForAllTokens() {
    useWatchTransferEvents("mcbBTC");
    useWatchTransferEvents("mDAI");
    useWatchTransferEvents("mFBTC");
    useWatchTransferEvents("mSolvBTC");
    useWatchTransferEvents("mswBTC");
    useWatchTransferEvents("mT");
    useWatchTransferEvents("mUSDC");
    useWatchTransferEvents("mUSDe");
    useWatchTransferEvents("mUSDT");
    useWatchTransferEvents("mxSolvBTC");
    useWatchTransferEvents("MUSD");
}
export { useWatchTransferEvents, useWatchTransferEventsForAllTokens };
//# sourceMappingURL=useWatchTransferEvents.js.map